const DOOR_DURATION_MS = 1350;
const REDUCED_MOTION_QUERY = "(prefers-reduced-motion: reduce)";

function isInternalNavigation(link: HTMLAnchorElement): boolean {
  const href = link.getAttribute("href");
  if (!href) return false;

  if (
    href.startsWith("#") ||
    href.startsWith("mailto:") ||
    href.startsWith("tel:") ||
    link.target === "_blank" ||
    link.hasAttribute("download")
  ) {
    return false;
  }

  return new URL(href, window.location.href).origin === window.location.origin;
}

export function initPageTransitions(): void {
  const prefersReducedMotion = window.matchMedia(REDUCED_MOTION_QUERY).matches;

  const openDoors = (): void => {
    document.body.classList.remove("is-leaving");
    requestAnimationFrame(() => document.body.classList.add("is-loaded"));
  };

  openDoors();

  if (!prefersReducedMotion) {
    document.addEventListener("click", (event) => {
      if (
        event.defaultPrevented ||
        event.button !== 0 ||
        event.metaKey ||
        event.ctrlKey ||
        event.shiftKey
      ) {
        return;
      }

      const target = event.target;
      const link = target instanceof Element ? target.closest<HTMLAnchorElement>("a") : null;
      if (!link || !isInternalNavigation(link)) return;

      event.preventDefault();
      document.body.classList.remove("is-loaded");
      document.body.classList.add("is-leaving");

      window.setTimeout(() => {
        window.location.assign(link.href);
      }, DOOR_DURATION_MS);
    });
  }

  window.addEventListener("pageshow", () => {
    document.body.classList.remove("is-leaving");
    requestAnimationFrame(() => document.body.classList.add("is-loaded"));
  });
}
